
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import Title from '../Title/index.vue'
import LazyImg from '@/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import type { AccountGiftUIData } from '@xt/client/entities/my-v2/types.d'
import { EnumProductTypeQuery } from '@xt/client/enums'
import { EnumMyAccountCount } from '@xt/client/enums/my'

@Observer
@Component({
  components: {
    Title,
    LazyImg,
    HeaderImage
  }
})
export default class MyAccount extends Vue {
  accountBackgroundImgList: Array<{
    imgUrl: string
    path: string
    text: string
  }> = [
    {
      imgUrl: this.$images.my_classroom_order,
      path: '/my/account?menu=order',
      text: EnumMyAccountCount.Order
    },
    {
      imgUrl: this.$images.my_classroom_bishan,
      path: '/my/account?menu=bishan',
      text: EnumMyAccountCount.Bishan
    },
    {
      imgUrl: this.$images.my_classroom_tongban,
      path: '/my/account?menu=coin',
      text: EnumMyAccountCount.Coin
    },
    {
      imgUrl: this.$images.my_classroom_coupon,
      path: '/my/account?menu=packs',
      text: EnumMyAccountCount.Packs
    },
    {
      imgUrl: this.$images.my_classroom_exchange,
      path: '/my/account?menu=exchange',
      text: ''
    }
  ]

  get EnumProductTypeQuery() {
    return EnumProductTypeQuery
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  orderGiftHandler(item: AccountGiftUIData) {
    this.UserStore.showOrderGiftsItem(item)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
